module.exports = __webpack_public_path__ + "files/58e8b8f4ed51bc8ce762d7c4c3588e18.png";